"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hamburger = function Hamburger(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M0 0V24H24V0H0ZM17 17.5H7C6.86739 17.5 6.74021 17.4473 6.64645 17.3536C6.55268 17.2598 6.5 17.1326 6.5 17C6.5 16.8674 6.55268 16.7402 6.64645 16.6464C6.74021 16.5527 6.86739 16.5 7 16.5H17C17.1326 16.5 17.2598 16.5527 17.3536 16.6464C17.4473 16.7402 17.5 16.8674 17.5 17C17.5 17.1326 17.4473 17.2598 17.3536 17.3536C17.2598 17.4473 17.1326 17.5 17 17.5ZM17 12.5H7C6.86739 12.5 6.74021 12.4473 6.64645 12.3536C6.55268 12.2598 6.5 12.1326 6.5 12C6.5 11.8674 6.55268 11.7402 6.64645 11.6464C6.74021 11.5527 6.86739 11.5 7 11.5H17C17.1326 11.5 17.2598 11.5527 17.3536 11.6464C17.4473 11.7402 17.5 11.8674 17.5 12C17.5 12.1326 17.4473 12.2598 17.3536 12.3536C17.2598 12.4473 17.1326 12.5 17 12.5ZM17 7.5H7C6.86739 7.5 6.74021 7.44732 6.64645 7.35355C6.55268 7.25979 6.5 7.13261 6.5 7C6.5 6.86739 6.55268 6.74021 6.64645 6.64645C6.74021 6.55268 6.86739 6.5 7 6.5H17C17.1326 6.5 17.2598 6.55268 17.3536 6.64645C17.4473 6.74021 17.5 6.86739 17.5 7C17.5 7.13261 17.4473 7.25979 17.3536 7.35355C17.2598 7.44732 17.1326 7.5 17 7.5Z",
    fill: props.foregroundColor
  }));
};

Hamburger.defaultProps = {
  altText: "Hamburger",
  backgroundColor: "#FFFFFF",
  foregroundColor: "#2D5AB4"
};
Hamburger.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Hamburger;
exports.default = _default;